import { InstanceScreen } from 'component/navigation/instance';

export default function LoginFragmentRedirectScreen() {
    return <InstanceScreen screenKey='fragmentRedirect' />;
}
